import React, { useState } from "react";
import { Button, Modal, Box, Typography, RadioGroup, FormControlLabel, Radio, Divider } from "@mui/material";
import { Check, CheckCircle, CheckCircleOutline, CheckCircleOutlined, CheckCircleRounded, CloudDone, InfoOutlined, Margin, SaveAs } from "@mui/icons-material";

export default function OutrasOpçoes(props: { fechar?: any; editavel: boolean; salvarPedido: any; }) {
  const [open, setOpen] = useState(true);
  const [selectedOption, setSelectedOption] = useState("Sincronizar - ERP");
  const [confirmOpen, setConfirmOpen] = useState(false);

  const filterIdStatus = [
    {
      value: 'Sincronizar - ERP',
      hint: 'Editável até enviar para o ERP',
      id: 3
    },
    {
      value: 'Orçamento',
      hint: 'Editável e NÃO será enviado para o ERP',
      id: 2
    },
    {
      value: 'Rascunho',
      hint: 'Editável e NÃO será enviado para o ERP',
      id: 1
    },
    {
      value: 'Cancelado',
      hint: 'Não Editável e NÃO será enviado para o ERP',
      id: 0
    }
  ]

  const handleOptionChange = (event: { target: { value: React.SetStateAction<string>; }; }) => setSelectedOption(event.target.value);

  const handleConfirm = () => {
    setOpen(false);
    setConfirmOpen(true);
  };

  const executeAction = () => {
    const statusFiltered = filterIdStatus.find((data) => data.value === selectedOption)
    props.salvarPedido(statusFiltered?.id)
    setConfirmOpen(false);
  };

  return (
    <div>

      <Modal open={open} onClose={props.fechar}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            height: 160,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3.5,
            borderRadius: 2,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginTop: -1.5 }}>
            <CheckCircleOutlined sx={{ fontSize: 20, color: '#0965c1', fontWeight: 'bold' }} />
            <Typography sx={{ color: "#0f3550", marginTop: 0, fontSize: '18px' }}>
              Escolha o Status para o Pedido:
            </Typography>
          </Box>

          <Divider sx={{ width: '100%', marginBottom: 1 }} />
          {/*<RadioGroup value={selectedOption} onChange={handleOptionChange}>
            <FormControlLabel value="Rascunho" control={<Radio />} label="Rascunho"/>
            <FormControlLabel value="Orçamento" control={<Radio />} label="Orçamento" />
            <FormControlLabel value="Pedido" control={<Radio />} label="Pedido" />
            <FormControlLabel value="Cancelado" control={<Radio />} label="Cancelado" />
          </RadioGroup>*/}
          {/* <RadioGroup value={selectedOption} onChange={handleOptionChange}>
            {filterIdStatus.map((option) => (
              <FormControlLabel
                key={option.id}
                value={option.value}
                control={<Radio />}
                label={
                  <Box>
                    <Typography
                      component="span"
                      sx={{
                        fontWeight: selectedOption === option.value ? "bold" : "normal",
                        color: selectedOption === option.value ? "#0965c1" : "#334155"
                      }}
                    >
                      {option.value}
                    </Typography>
                  </Box>
                }
              />
            ))}
          </RadioGroup> */}
          <RadioGroup
            value={selectedOption}
            onChange={handleOptionChange}
            sx={{
              display: 'flex',
              gap: 0.2 // Espaçamento entre as opções
            }}
          >
            {filterIdStatus.map((option) => (
              <FormControlLabel
                key={option.id}
                value={option.value}
                // Ajuste de padding do rádio para ficar compacto
                control={<Radio size="small" sx={{ p: 0.3 }} />}
                // Remove margens laterais padrão para aproximar os elementos
                sx={{ ml: 0, mr: 0 }}
                label={
                  <Box>
                    <Typography
                      component="span"
                      sx={{
                        fontSize: '15px',
                        fontWeight: selectedOption === option.value ? "bold" : "normal",
                        color: selectedOption === option.value ? "#0965c1" : "#334155"
                      }}
                    >
                      {option.value}
                    </Typography>
                  </Box>
                }
              />
            ))}
          </RadioGroup>

          <Box mt={2} display="flex" justifyContent="space-between">
            <Button
              variant="outlined"
              onClick={props.fechar}
              sx={{
                backgroundColor: "#EEFBFF",
                color: "#0965c1",
                minHeight: 30,  
                py: 0.4,
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                borderRadius: '6px',
                padding: '0 12px',
                width: '30%',
                height: '30px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontFamily: 'sans-serif',
                textTransform: 'none',
              }}>
              Fechar
            </Button>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0965c1",
                color: "#fff",
                minHeight: 30,
                py: 0.4,
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                borderRadius: '6px',
                padding: '0 12px',
                width: '30%',
                height: '30px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontFamily: 'sans-serif',
                textTransform: 'none',
              }}
              onClick={handleConfirm}
              disabled={!selectedOption}
            >
              Confirmar
            </Button>
          </Box>
        </Box>
      </Modal>


      <Modal open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 'fit-content',
            height: 90,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, marginTop: -1.5 }}>
            <InfoOutlined sx={{ fontSize: 20, color: '#0965c1' }} />
            <Typography sx={{ lineHeight: 1, color: "#0f3550", fontSize: '18px' }}>
              Confirmação
            </Typography>
          </Box>

          <Divider sx={{ width: '100%', marginBottom: 1.5, marginTop: -0.5 }} />
          <Typography mb={3} sx={{ color: "#334155" }}>
            Salvar pedido com o status de <strong>{selectedOption}</strong>?
          </Typography>
          <Box display="flex" justifyContent="space-between" marginBottom={1}>
            <Button
              variant="outlined"
              onClick={props.fechar}
              sx={{
                backgroundColor: "#EEFBFF",
                color: "#0965c1",
                minHeight: 30,
                py: 0.4,
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                borderRadius: '6px',
                padding: '0 12px',
                width: '25%',
                height: '30px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontFamily: 'sans-serif',
                textTransform: 'none',
              }}>
              Não
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={executeAction}
              sx={{
                backgroundColor: "#0965c1",
                color: "#fff",
                minHeight: 30,
                py: 0.4,
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                borderRadius: '6px',
                padding: '0 12px',
                width: '25%',
                height: '30px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontFamily: 'sans-serif',
                textTransform: 'none',
              }}>
              Sim
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};